import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FFE15A"
  }} d="M512,126.621c0-21.177-17.167-38.345-38.345-38.345H38.345C17.167,88.276,0,105.443,0,126.621V256  h512V126.621z" /><path style={{
    fill: "#FF4B55"
  }} d="M38.345,423.724h435.31c21.177,0,38.345-17.167,38.345-38.345V256H0v129.379  C0,406.557,17.167,423.724,38.345,423.724z" /><path style={{
    fill: "#73AF00"
  }} d="M38.115,423.719h132.551V88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38  C0,406.479,17.045,423.594,38.115,423.719z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };